<template>
  <div class="help-box">
    <Header />

    <div class="help-nav">
      <div class="catalog-header">
        <a-row v-if="screenWidth >= 992">
          <a-col :span="12">
            <a-breadcrumb>
              <a-breadcrumb-item
                @click="handleBackHelp()"
                style="cursor: pointer"
                >{{ $t(`navbar.help`) }}</a-breadcrumb-item
              >
              <a-breadcrumb-item
                ><div class="nav-title">
                  {{ objData.title }}
                </div></a-breadcrumb-item
              >
            </a-breadcrumb>
          </a-col>
          <a-col :span="12">
            <a-input-search
              v-model:value="searchValue"
              :placeholder="$t(`tips.tip53`)"
              @search="openSearch"
            />
          </a-col>
        </a-row>
        <a-row v-else>
          <a-col :span="24">
            <a-input-search
              v-model:value="searchValue"
              :placeholder="$t(`tips.tip53`)"
              @search="openSearch"
            />
          </a-col>
          <a-col :span="24" style="margin-top: 10px">
            <a-breadcrumb>
              <a-breadcrumb-item
                @click="router.push('/help')"
                style="cursor: pointer"
                >{{ $t(`navbar.help`) }}</a-breadcrumb-item
              >
              <a-breadcrumb-item
                ><div class="nav-title">
                  {{ objData.title }}
                </div></a-breadcrumb-item
              >
            </a-breadcrumb>
          </a-col>
        </a-row>
      </div>
      <div class="catalog-box">
        <div class="catalog-title">
          <span class="iconfont icon-jiaocheng"></span>{{ objData.title }}
        </div>
        <div>
          <div
            class="catalog-item"
            v-for="(item, index) in objData.list"
            :key="index"
            @click="handleClick(item)"
          >
            <div class="catalog-item-text">
              <span class="iconfont icon-dian"></span>{{ item.title }}
            </div>
            <div style="background: #fff; z-index: 1; padding-left: 15px">
              {{ formatDate(item.create_time) }}
            </div>
            <a-divider dashed class="divider" />
          </div>
        </div>
      </div>
      <div class="pagination">
        <a-pagination
          v-model:current="queryForm.page"
          v-model:pageSize="queryForm.size"
          :total="objData.count"
          :size="screenWidth > 992 ? '' : 'small'"
          :show-total="
            screenWidth > 992
              ? language == 'zh'
                ? (total) => `共有 ${total}条数据`
                : (total) => `There are ${total} data in total`
              : (total) => ''
          "
          @change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Header from "./components/Header.vue";
import { formatDate } from "../../utils/formatTime";
import { useRouter, useRoute } from "vue-router";
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onBeforeMount,
  onMounted,
} from "vue";
export default defineComponent({
  components: {
    Header,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axioshanma;
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      searchValue: "",
      language: proxy.$i18n.locale,
      title: "",
      queryForm: {
        page: 1,
        size: 20,
        a_id: "",
      },
      objData: [],
      screenWidth: 1920,
    });
    onBeforeMount(() => {
      state.screenWidth = document.body.clientWidth;
    });
    onMounted(() => {
      state.title = route.query.title;
      state.queryForm.a_id = route.query.id;
      getList();
    });

    const getList = () => {
      axios("/api/ayuda.article/articleIdList", state.queryForm).then((res) => {
        console.log(res);
        state.objData = res;
      });
    };

    const handleClick = (value) => {
      let a_id;
      if(value.type == 1){
        a_id = value.sub_id
      }else{
        a_id = value.a_id
      }
      router.push({
        path: "/helpDetail",
        query: {
          id: a_id,
        },
      });
    };
    const handleSizeChange = (e) => {
      getList();
    };
    const handleBackHelp = () => {
      if (localStorage.getItem("showPCHelpType")) {
        let showPCHelpType = localStorage.getItem("showPCHelpType");
        router.push({
          path: "/help",
          query: {
            type: showPCHelpType,
          },
        });
      } else {
        router.push("/help");
      }
    };
    const openSearch = () => {
      // let routeData = router.resolve({
      //   path: "/helpSearch",
      //   query: { searchValue: state.searchValue },
      // });
      // window.open(routeData.href, "_blank");
      router.push({
        path: "/helpSearch",
        query: { searchValue: state.searchValue },
      })
      state.searchValue = "";
    };

    return {
      router,
      ...toRefs(state),
      handleClick,
      openSearch,
      formatDate,
      handleBackHelp,
      handleSizeChange,
    };
  },
});
</script>
<style scoped>
::v-deep(.ant-input-affix-wrapper) {
  width: 100%;
}
.icon-arrow-right {
  font-size: 16px;
}
.help-box {
  background: #f3f6fa;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
}
.help-nav {
  width: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 28px;
  margin: 1px auto;
  margin-top: 88px;
}
.nav-title {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: bottom;
}
.catalog-header {
  width: 100%;
}

.catalog-box {
  width: 100%;
  height: 675px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 26px;
  padding: 32px;
  overflow: hidden;
  overflow-y: auto;
}
.catalog-title {
  height: 28px;
  font-size: 18px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 28px;
  margin-bottom: 16px;
}

.icon-jiaocheng {
  font-size: 24px;
  margin-right: 5px;
  float: left;
}
.catalog-item {
  height: 28px;
  font-size: 16px;
  color: #535d6c;
  line-height: 28px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}
.catalog-item-text {
  background: #fff;
  z-index: 1;
  padding-right: 15px;
  max-width: 65%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.icon-dian {
  float: left;
  color: #d6dce6;
}
.divider {
  border-color: #d6dce6;
  position: absolute;
  height: 2px;
  left: 0;
  top: 15px;
  width: 100%;
  z-index: 0;
  margin: 0;
}
.pagination {
  width: 100%;
  justify-content: flex-end;
}
@media only screen and (max-width: 1300px) {
}
@media only screen and (max-width: 992px) {
  .icon-arrow-right {
    font-size: 16px;
  }
  .help-nav {
    padding: 20px 20px 0;
    margin: 0;
    margin-top: 55px;

    width: 100%;
  }
  .catalog-header {
    width: 100%;
    height: 55px;
  }

  .catalog-box {
    width: 100%;
    height: calc(100vh - 200px);
    border-radius: 4px;
    margin-top: 20px;
    padding: 10px;
  }
  .catalog-title {
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .icon-jiaocheng {
    font-size: 16px;
    margin-right: 5px;
  }
  .catalog-item {
    height: 24px;
    font-size: 10px;
    line-height: 24px;
    margin-bottom: 5px;
  }
  .catalog-item-text {
    padding-right: 10px;
    max-width: 50%;
  }
  .icon-dian {
    font-size: 18px;
  }
  .divider {
    top: 13px;
  }
  .pagination {
    margin-top: 10px;
  }
}
</style>
